import React from 'react';

// Define the interface for the steps
interface StepTimelineProps {
  steps: string[]; // Array of step titles
  currentStep: number; // The current active step (0-based index)
}

const StepTimeline: React.FC<StepTimelineProps> = ({ steps, currentStep }) => {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-2">
        {steps.map((_, index) => (
          <div
            key={index}
            className={`rounded w-6 h-6 ${index === currentStep - 1 ? 'bg-primary' : 'bg-gray-100'}`}
          ></div>
        ))}
      </div>
      <p className="uppercase font-bold text-gray-400">
        Step {currentStep} of {steps.length}
      </p>
    </div>
  );
};

export default StepTimeline;
